import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './RoundFloatingIcon.css';
import { useDispatch, useSelector } from 'react-redux';
import { openModal } from 'features/modalSlice';
import { Click2CallModal } from 'components/click2CallModal';
import { getOpenWidgetBtnPosition } from 'lib';

const RoundFloatingIcon = ({ icon }) => {
    const dispatch = useDispatch();
    const [isMessageVisible, setIsMessageVisible] = useState(false);
    const isClick2CallModalOpen = useSelector(
        (state) => state.modal.isClick2CallModalOpen
    );
    const widgetPosition = useSelector(
        (state) => state.miniBookingWidget.widgetPosition
    );

    let openWidgetButtonStyles = getOpenWidgetBtnPosition(
        widgetPosition?.position
    );

    const click2CallFloatingMessage = useSelector(
        (state) =>
            state.miniBookingWidget?.data?.click2Call?.floatingTextMessage
    );
    const primaryColor = useSelector(
        (state) => state.miniBookingWidget?.data?.click2Call?.primaryColor
    );
    const secondaryColor = useSelector(
        (state) => state.miniBookingWidget?.data?.click2Call?.secondaryColor
    );

    const btnContainerStyles = widgetPosition?.position?.includes('left')
        ? { marginLeft: 0 }
        : { marginLeft: 'auto' };

    openWidgetButtonStyles = {
        ...openWidgetButtonStyles,
        backgroundColor: '#' + secondaryColor,
        color: '#' + primaryColor,
    };

    const handleClick = (event) => {
        event.stopPropagation();
        if (!isClick2CallModalOpen) {
            dispatch(
                openModal({
                    modalId: 'Click2CallModal',
                })
            );
        }
    };

    const handleCloseMessage = (event) => {
        event.stopPropagation();
        setIsMessageVisible(false);
        const expiryTime = Date.now() + 5 * 60 * 1000; // 5 minutes from now
        localStorage.setItem('messageClosedAt', JSON.stringify(expiryTime));
    };

    useEffect(() => {
        const storedExpiryTime = localStorage.getItem('messageClosedAt');
        if (storedExpiryTime) {
            const expiryTime = JSON.parse(storedExpiryTime);
            const currentTime = Date.now();

            if (currentTime > expiryTime) {
                localStorage.removeItem('messageClosedAt');
                setIsMessageVisible(true);
            } else {
                setIsMessageVisible(false);
            }
        } else {
            setIsMessageVisible(true);
        }
    }, []);

    const isBottomRight = widgetPosition.position === 'bottom-right';

    return (
        <>
            <Click2CallModal closeOnOutsideClick={false} />
            {isMessageVisible && (
                <div
                    className={`message-container ${
                        isBottomRight ? 'bottom-right' : ''
                    }`}
                    onClick={handleClick}
                    style={btnContainerStyles}
                >
                    <span
                        className="message"
                        style={openWidgetButtonStyles}
                        dangerouslySetInnerHTML={{
                            __html: click2CallFloatingMessage,
                        }}
                    ></span>
                    <button
                        className="close-button"
                        style={openWidgetButtonStyles}
                        onClick={handleCloseMessage}
                    >
                        &times;
                    </button>
                </div>
            )}
            <div
                className={`ab-button-container ${
                    isBottomRight ? 'bottom-right' : ''
                }`}
            >
                <div
                    className={`round-icon ${
                        isBottomRight ? 'bottom-right' : ''
                    }`}
                    style={openWidgetButtonStyles}
                    onClick={handleClick}
                >
                    {React.cloneElement(icon, { color: '#' + primaryColor })}
                </div>
            </div>
        </>
    );
};

RoundFloatingIcon.propTypes = {
    icon: PropTypes.node.isRequired,
};

export default RoundFloatingIcon;
